const useScroll = {
  scrollTop: () => {
    const ele = document.getElementsByClassName("app-content")[0];
    ele.scrollTo({ top: 0, behavior: "smooth" });
  },
};

export default useScroll;
